import { VBtn } from 'vuetify/lib/components/VBtn';
import { VOverlay } from 'vuetify/lib/components/VOverlay';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VBtn,{attrs:{"color":"primary"},on:{"click":function($event){_vm.dialog = true}}},[_vm._v("Extender pantalla")]),_c('DashboardNyx',{attrs:{"show-filters":!_vm.dialog,"fullscreen":_vm.dialog},on:{"close":function($event){_vm.dialog = false}}}),_c(VOverlay,{attrs:{"value":_vm.dialog,"opacity":"0.6","z-index":2000}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }